<template>
  <v-container
    :class="['daily-schedule', isGroup ? 'group' : '']"
    fluid
  >
    <template>
      <v-container
        fluid
      >
        <portal to="page-title">
          <template v-if="$vuetify.breakpoint.mdAndDown">
            <v-container class="schedule-header py-0 mx-0">
              <v-row justify="space-between">
                <v-col
                  align-self="center"
                  class="px-1"
                  cols="auto"
                >
                  <v-select
                    v-model="activeDailyScheduleType"
                    class="daily-schedule-picker subtitle-2"
                    dense
                    hide-details
                    item-text="name"
                    item-value="id"
                    :items="dailyScheduleTypes"
                    :menu-props="{ top: false, offsetY: true }"
                    outlined
                    :style="selectorsStyle"
                    return-object
                    @change="onDailyScheduleTypeChange"
                  >
                    <template v-slot:item="{ attrs, item, on }">
                      <v-list-item
                        class="daily-schedule-item"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ item.name }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-select>
                </v-col>
                <v-col
                  align-self="center"
                  class="px-0"
                  cols="auto"
                >
                  <v-row
                    align="center"
                    class="ml-1"
                  >
                    <DepartmentGroupSelector
                      :style="selectorsStyle"
                    />
                  </v-row>
                </v-col>
                <template v-if="$vuetify.breakpoint.width <= ELLIPSIS_BREAKPOINT">
                  <v-spacer />
                  <v-col
                    align-self="center"
                    cols="auto"
                  >
                    <v-menu
                      min-width="200"
                      :offset-y="true"
                    >
                      <template
                        v-slot:activator="{ on }"
                      >
                        <v-btn
                          class="mx-1 account-icon"
                          icon
                          small
                          v-on="on"
                        >
                          <v-icon>
                            fal fa-ellipsis-v
                          </v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item
                          @click="toggleHelpPanel"
                        >
                          <v-list-item-action>
                            <v-icon small>
                              fal fa-info-circle
                            </v-icon>
                          </v-list-item-action>
                          <v-list-item-title>
                            {{ $t('labels.information') }}
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-col>
                </template>
                <template v-else>
                  <v-spacer />
                </template>
                <template v-if="!isGroup && $vuetify.breakpoint.lgAndUp">
                  <v-col
                    align-self="center"
                    cols="auto"
                  >
                    <portal-target name="daily-schedule-state" />
                  </v-col>
                  <v-spacer />
                </template>
              </v-row>
            </v-container>
          </template>
          <template v-else>
            <v-row
              class="schedule-header"
              justify="space-between"
            >
              <v-col
                align-self="center"
                cols="auto"
              >
                <v-select
                  v-model="activeDailyScheduleType"
                  class="daily-schedule-picker subtitle-2"
                  dense
                  hide-details
                  item-text="name"
                  item-value="id"
                  :items="dailyScheduleTypes"
                  :menu-props="{ top: false, offsetY: true }"
                  outlined
                  style="max-width: 200px"
                  return-object
                  @change="onDailyScheduleTypeChange"
                >
                  <template v-slot:item="{ attrs, item, on }">
                    <v-list-item
                      class="daily-schedule-item"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ item.name }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </v-col>
              <v-col
                align-self="center"
                cols="auto"
              >
                <v-row
                  align="center"
                  class="ml-1"
                >
                  <DepartmentGroupSelector />
                </v-row>
              </v-col>
              <v-spacer />
              <template v-if="!isGroup">
                <v-col
                  align-self="center"
                  cols="auto"
                >
                  <v-row
                    align="center"
                    class="ml-1"
                  >
                    <portal-target name="daily-schedule-state" />
                  </v-row>
                </v-col>
                <v-spacer />
              </template>
              <v-col
                align-self="center"
                class="pr-0"
                cols="auto"
              >
                <v-tooltip
                  bottom
                  nudge-top="10"
                >
                  <template #activator="{ on: tooltipOn, attrs }">
                    <v-btn
                      class="mx-1"
                      icon
                      v-bind="attrs"
                      v-on="{...tooltipOn, 'click': toggleHelpPanel}"
                    >
                      <v-icon color="primary">
                        fal fa-info-circle
                      </v-icon>
                    </v-btn>
                  </template>
                  <span class="body-2">
                    {{ $t('labels.information') }}
                  </span>
                </v-tooltip>
              </v-col>
            </v-row>
          </template>
        </portal>
        <v-container
          class="body-container actions"
          fluid
        >
          <v-row
            align="center"
            no-gutters
            :style="[$vuetify.breakpoint.smAndDown ? {'text-align': 'center'} : {}]"
          >
            <v-col
              class="date-navigation subtitle-2 font-weight-medium primary--text text-no-wrap"
              cols="12"
              sm="auto"
            >
              <span>
                {{ moment(date).format(dateFormatString) }}
              </span>
              <v-btn
                class="grey--text text--darken-3 mb-1"
                icon
                @click="loadNewContent(previousDay)"
              >
                <v-icon
                  color="primary"
                  size="16"
                >
                  far fa-chevron-left
                </v-icon>
              </v-btn>
              <v-menu
                ref="datePicker"
                v-model="showDatePicker"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="primary--text mb-1"
                    icon
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon
                      color="gray"
                      size="18"
                    >
                      far fa-calendar-day
                    </v-icon>
                  </v-btn>
                </template>
                <v-date-picker
                  :value="date"
                  @change="(newDate) => loadNewContent(setDate, [newDate])"
                >
                  <v-btn
                    color="primary"
                    :disabled="date === today"
                    outlined
                    small
                    @click="goToToday"
                  >
                    {{ $t('labels.today') }}
                  </v-btn>
                </v-date-picker>
              </v-menu>
              <v-btn
                class="grey--text text--darken-3 mb-1"
                icon
                @click="loadNewContent(nextDay)"
              >
                <v-icon
                  color="primary"
                  size="16"
                >
                  far fa-chevron-right
                </v-icon>
              </v-btn>
              <v-btn
                class="share mb-1 ml-6"
                color="secondary"
                :text="$vuetify.breakpoint.lgAndUp"
                :icon="$vuetify.breakpoint.mdAndDown"
                :title="$t('labels.share')"
                @click.prevent="shareDialogOpened = true"
              >
                <v-icon
                  size="20"
                >
                  fas fa-share-alt
                </v-icon>
                <span
                  v-if="$vuetify.breakpoint.lgAndUp"
                  class="ml-2"
                >
                  {{ $t('labels.share') }}
                </span>
              </v-btn>
              <!-- A single department column shows its finalize button here. "slim" avoids a full-width wrapper. -->
              <portal-target
                v-if="!isGroup"
                name="daily-schedule-finalize"
                slim
              />
            </v-col>
            <v-spacer />
            <v-col
              cols="12"
              sm="auto"
            >
              <div
                :class="['actions', $vuetify.breakpoint.smAndDown ? '' : 'float-right']"
              >
                <portal-target
                  v-if="!isGroup"
                  name="daily-schedule-actions"
                  slim
                />
                <v-tooltip
                  v-if="$can('view', 'openShift')"
                  top
                >
                  <template #activator="{ on, attrs }">
                    <v-badge
                      avatar
                      class="badge-panel count"
                      color="error"
                      :content="openShiftCount"
                      overlap
                      :value="openShiftCount > 0"
                    >
                      <v-btn
                        :class="actionStyles.viewOpenShift.button.classes"
                        icon
                        value="viewOpenShift"
                        v-bind="attrs"
                        v-on="on"
                        @click="setPanelName('viewOpenShift')"
                      >
                        <v-icon
                          :class="actionStyles.viewOpenShift.icon.classes"
                          size="16"
                        >
                          fal fa-list
                        </v-icon>
                      </v-btn>
                    </v-badge>
                  </template>
                  <span class="body-2">
                    {{ $t('labels.viewOpenShift') }}
                  </span>
                </v-tooltip>
                <v-tooltip
                  top
                >
                  <template #activator="{ on, attrs }">
                    <v-btn
                      :class="actionStyles.filters.button.classes"
                      icon
                      value="filters"
                      v-bind="attrs"
                      v-on="on"
                      @click="setPanelName('filters')"
                    >
                      <v-icon
                        v-if="hasFilters && pagePanelName !== 'filters'"
                        :class="actionStyles.filters.icon.classes"
                        size="16"
                      >
                        fas fa-filter
                      </v-icon>
                      <v-icon
                        v-else
                        :class="actionStyles.filters.icon.classes"
                        size="16"
                      >
                        fal fa-filter
                      </v-icon>
                    </v-btn>
                  </template>
                  <span class="body-2">
                    {{ $t('labels.filter') }}
                  </span>
                </v-tooltip>
              </div>
            </v-col>
          </v-row>
        </v-container>
        <v-container
          class="body-container pa-0"
          fluid
        >
          <div :class="['department-columns', isGroup ? 'group' : '']">
            <DepartmentDailySchedule
              v-for="department in activeDepartments"
              :key="`${department.id}-${isGroup}`"
              ref="columns"
              :compact="isGroup"
              :daily-schedule-type="confirmedDailyScheduleType"
              :date="date"
              :department-data="departmentData[department.id] || null"
              :department-id="department.id"
              :filters="filters"
              :load-data="false"
              :show-skeleton-loader="showSkeletonLoader"
            />
          </div>
        </v-container>
        <v-dialog
          v-model="shareDialogOpened"
          persistent
          width="500"
        >
          <v-card id="shareScheduleDialog">
            <v-card-title
              class="primary--text subtitle-2 py-2"
            >
              {{ $t('labels.share') }}
              <v-spacer />
              <v-btn
                v-if="sharingSummaryState !== SHARING_SUMMARY_IN_PROGRESS"
                class="float-right"
                icon
                x-small
                @click="shareDialogOpened = false"
              >
                <v-icon>fal fa-times</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider class="mx-2" />
            <template v-if="loadingShareDialog">
              <v-row
                align="center"
                style="height: 540px"
              >
                <v-spacer />
                <v-col cols="6">
                  <v-row class="text-center">
                    <v-col class="text-center">
                      <v-progress-circular
                        color="info"
                        indeterminate
                        size="75"
                        width="6"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="text-center">
                      <span>{{ $t('descriptions.loading') }}</span>
                    </v-col>
                  </v-row>
                </v-col>
                <v-spacer />
              </v-row>
            </template>
            <template v-else>
              <v-card-text class="mt-4 pb-0">
                <div class="body-2">
                  {{ $t('descriptions.shareSummary') }}
                </div>
                <br>
                <v-card
                  class="px-0 lighten-5"
                  color="grey"
                  outlined
                >
                  <v-data-table
                    class="share-list mx-4"
                    dense
                    fixed-header
                    :headers="shareSummaryHeaders"
                    height="400"
                    hide-default-footer
                    :items="shareWithDepartments"
                    :items-per-page="shareWithDepartments.length"
                    mobile-breakpoint=""
                    single-select
                  >
                    <template #header.dailySchedule="{ header }">
                      <v-btn
                        v-if="shareCount[header.id] === shareWithDepartments.length"
                        :disabled="sharingSummaryState === SHARING_SUMMARY_IN_PROGRESS"
                        icon
                        :ripple="false"
                        height="12"
                        width="12"
                        @click="shareWithZeroDepartments(header.id)"
                      >
                        <v-icon
                          color="info"
                          size="14"
                        >
                          fas fa-check-square
                        </v-icon>
                      </v-btn>
                      <v-btn
                        v-else-if="shareCount[header.id] > 0"
                        :disabled="sharingSummaryState === SHARING_SUMMARY_IN_PROGRESS"
                        icon
                        :ripple="false"
                        height="12"
                        width="12"
                        @click="shareWithZeroDepartments(header.id)"
                      >
                        <v-icon
                          color="info"
                          size="14"
                        >
                          fas fa-minus-square
                        </v-icon>
                      </v-btn>
                      <v-btn
                        v-else
                        :disabled="sharingSummaryState === SHARING_SUMMARY_IN_PROGRESS"
                        icon
                        :ripple="false"
                        height="12"
                        width="12"
                        @click="shareWithAllDepartments(header.id)"
                      >
                        <v-icon
                          size="14"
                        >
                          fal fa-square
                        </v-icon>
                      </v-btn>
                      <span
                        class="body-2 grey--text text--darken-3 ml-2"
                        :style="{cursor: sharingSummaryState !== SHARING_SUMMARY_IN_PROGRESS ? 'pointer' : ''}"
                        @click="shareCount[header.id] > 0 ? shareWithZeroDepartments(header.id) : shareWithAllDepartments(header.id)"
                      >
                        {{ $t('labels.selectAll') }}
                      </span>
                    </template>
                    <template #item.department="{ item }">
                      <span
                        class="grey--text text--darken-3 dept-name d-inline-block text-truncate"
                        :title="item.name"
                      >
                        {{ item.name }}
                      </span>
                      <v-progress-linear
                        v-if="item.status === 'pending'"
                        class="share-progress"
                        color="nb-azure"
                        rounded
                        value="100"
                      />
                      <v-progress-linear
                        v-else-if="item.status === 'in_progress'"
                        class="share-progress"
                        indeterminate
                        color="secondary"
                        rounded
                      />
                      <template v-else-if="item.status === 'success'">
                        <v-progress-linear
                          class="share-progress"
                          color="secondary"
                          rounded
                          value="100"
                        />
                        <v-icon
                          class="ml-1 share-progress-status"
                          color="secondary"
                          size="10"
                        >
                          far fa-check
                        </v-icon>
                      </template>
                      <template v-else-if="item.status === 'failed'">
                        <v-progress-linear
                          class="share-progress"
                          color="error"
                          rounded
                          value="100"
                        />
                        <v-icon
                          class="ml-1 share-progress-status"
                          color="error"
                          size="10"
                        >
                          far fa-exclamation-triangle
                        </v-icon>
                      </template>
                    </template>
                    <template #item.dailySchedule="{ header, item }">
                      <v-simple-checkbox
                        v-model="item.dailySchedules[header.id].send"
                        class="extra-dense-checkbox d-inline-block daily-schedule-check"
                        color="info"
                        :disabled="sharingSummaryState === SHARING_SUMMARY_IN_PROGRESS"
                        :ripple="false"
                      />
                      <span
                        class="ml-2 grey--text text--darken-3 daily-schedule-label d-inline-block text-truncate"
                        :style="{cursor: sharingSummaryState !== SHARING_SUMMARY_IN_PROGRESS ? 'pointer' : ''}"
                        @click="toggleDailyScheduleShare(item, header)"
                      >
                        {{ header.text }}
                      </span>
                      <div class="grey--text caption-2 mt-n2">
                        {{ item.dailySchedules[header.id].lastShared }}
                        <v-tooltip
                          v-if="item.dailySchedules[header.id].lastShared"
                          right
                        >
                          <template #activator="{ on, attrs }">
                            <v-icon
                              color="grey"
                              size="10"
                              style="vertical-align: inherit;"
                              v-bind="attrs"
                              v-on="on"
                            >
                              fal fa-info-circle
                            </v-icon>
                          </template>
                          <span class="body-2">
                            {{ item.dailySchedules[header.id].lastSharedDetails }}
                          </span>
                        </v-tooltip>
                      </div>
                    </template>
                  </v-data-table>
                </v-card>
                <EmployeeSelector
                  class="mt-4"
                  :disabled="sharingSummaryState === SHARING_SUMMARY_IN_PROGRESS"
                  :filters="employeeSelectorFilter"
                  :hint="$t('descriptions.emailAdditionalRecipients')"
                  :label="$t('labels.emailAdditionalRecipients')"
                  multiple
                  @change="updateAdditionalRecipients"
                />
                <v-checkbox
                  v-if="hasProps(shareOptions, 'showNonDutyEmployees')"
                  v-model="shareOptions.showNonDutyEmployees"
                  class="extra-dense-checkbox mt-1"
                  color="secondary"
                  dense
                  :label="$t('labels.includeNonWorkingShifts')"
                  :disabled="sharingSummaryState === SHARING_SUMMARY_IN_PROGRESS"
                />
                <v-progress-linear
                  v-if="shareWithAdditionalRecipients.status === 'pending'"
                  class="share-progress"
                  color="nb-azure"
                  rounded
                  value="100"
                />
                <v-progress-linear
                  v-else-if="shareWithAdditionalRecipients.status === 'in_progress'"
                  class="share-progress"
                  indeterminate
                  color="secondary"
                  rounded
                />
                <template v-else-if="shareWithAdditionalRecipients.status === 'success'">
                  <v-progress-linear
                    class="share-progress"
                    color="secondary"
                    rounded
                    value="100"
                  />
                  <v-icon
                    class="ml-1 share-progress-status"
                    color="secondary"
                    size="10"
                  >
                    far fa-check
                  </v-icon>
                </template>
                <template v-else-if="shareWithAdditionalRecipients.status === 'failed'">
                  <v-progress-linear
                    class="share-progress"
                    color="error"
                    rounded
                    value="100"
                  />
                  <v-icon
                    class="ml-1 share-progress-status"
                    color="error"
                    size="10"
                  >
                    far fa-exclamation-triangle
                  </v-icon>
                </template>
              </v-card-text>
              <v-card-actions class="px-6">
                <v-btn
                  v-if="failedSharingSummary"
                  class="my-3 px-4 mr-1"
                  text
                  @click="retryShareSummary"
                >
                  {{ $t('labels.retry') }}
                </v-btn>
                <v-spacer />
                <v-btn
                  class="my-3 px-4 download-pdf"
                  color="primary"
                  :disabled="!selectedDepartmentsToShare || sharingSummaryState === SHARING_SUMMARY_IN_PROGRESS"
                  outlined
                  @click="downloadSummary"
                >
                  <span>
                    {{ $t('labels.downloadPDF') }}
                  </span>
                </v-btn>
                <v-btn
                  class="my-3 px-4"
                  color="accent"
                  :disabled="!selectedDepartmentsToShare || sharingSummaryState === SHARING_SUMMARY_IN_PROGRESS"
                  @click="emailSummary"
                >
                  <span>
                    {{ $t('labels.emailPDF') }}
                  </span>
                </v-btn>
              </v-card-actions>
            </template>
          </v-card>
        </v-dialog>
      </v-container>
      <SidePanel
        :panels="sidePanels"
      />
    </template>
  </v-container>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import { DATE_FORMAT, getUnsavedChangesDialogProps } from '@/utils';
import {
  calculateStartOfWeek,
  filterData,
  getDefaultFilters,
  groupData,
  prepareLastDates,
  prepareShiftHours,
  sortData,
  sortAndGroupShifts
} from '@/utils/scheduling';
import Help from '@/views/scheduling/panels/Help';
import SidePanel from '@/components/SidePanel';
import DepartmentGroupSelector from '@/components/DepartmentGroupSelector';
import EmployeeSelector from '@/components/EmployeeSelector';
import DepartmentDailySchedule from '@/views/scheduling/DepartmentDailySchedule';
import CreateOpenShift from '@/views/scheduling/open_shifts/Create';
import OpenShiftDetails from '@/views/scheduling/open_shifts/Details';
import OpenShiftsList from '@/views/scheduling/open_shifts/List';
import Filters from '@/views/scheduling/panels/Filters';
import { showStatus } from '@/plugins/vue-notification';
import { ACCOUNT_STATE, CONTENT_TYPES } from '@/services/constants';
import { RequestCanceledError } from '@/services/errors';
import { getDailyScheduleDefaultOptions, getDailyScheduleTemplate } from '@/views/scheduling/pdf_templates/daily_schedule';

const DeepDiff = require('deep-diff').diff;
// Owner of the panels opened by the page itself (filters, open shifts). Column panels are owned by their department ID.
const PAGE_PANEL_OWNER = 'page';

export default {
  components: {
    DepartmentDailySchedule,
    DepartmentGroupSelector,
    EmployeeSelector,
    SidePanel
  },
  provide () {
    return {
      dailySchedulePage: this
    };
  },
  props: {
    typeId: {
      default: null,
      type: [Number, String]
    },
    showSkeletonLoader: {
      default: true,
      type: Boolean
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (!vm.$can('view', 'dailySchedule')) {
        next('/page_not_found');
      }
    });
  },
  data () {
    const activeDepartmentIds = _.map(this.$store.getters['org/getActiveDepartmentGroup'](), 'id');
    const dailyScheduleTypes = _.sortBy(this.$store.state.org.dailyScheduleTypes, ['name']);

    let activeDailyScheduleType = dailyScheduleTypes[0];
    if (this.typeId) {
      const dailyScheduleType = _.find(dailyScheduleTypes, (d) => d.id === this.typeId);
      if (dailyScheduleType) {
        activeDailyScheduleType = dailyScheduleType;
      }
    }

    const shareWithDepartments = [];
    const departments = _.filter(this.$store.state.org.departments, (department) => department.partakeInScheduling);
    for (let i = 0, count = departments.length; i < count; i++) {
      const departmentItem = {
        dailySchedules: {},
        id: departments[i].id,
        name: departments[i].name,
        status: 'ready' // null, pending, in_progress, success, failed
      };
      for (let j = 0, dailyCount = dailyScheduleTypes.length; j < dailyCount; j++) {
        departmentItem.dailySchedules[dailyScheduleTypes[j].id] = {
          id: dailyScheduleTypes[j].id,
          send: activeDepartmentIds.includes(departments[i].id) && dailyScheduleTypes[j].id === activeDailyScheduleType.id,
          lastShared: '',
          lastSharedDetails: ''
        };
      }
      shareWithDepartments.push(departmentItem);
    }

    const date = this.$store.state.scheduling.dailySchedule.date || moment().format(DATE_FORMAT);
    const SHARING_SUMMARY_READY = 'ready';
    return {
      ELLIPSIS_BREAKPOINT: 600,
      SHARING_SUMMARY_READY,
      SHARING_SUMMARY_IN_PROGRESS: 'in_progress',
      SHARING_SUMMARY_FINISHED: 'finished',
      SHARING_SUMMARY_DOWNLOAD_TYPE: 'download',
      SHARING_SUMMARY_EMAIL_TYPE: 'email',
      activeDailyScheduleType,
      previousActiveDailyScheduleType: _.cloneDeep(activeDailyScheduleType),
      // Daily schedule type given to the columns. Unlike activeDailyScheduleType (bound to the select),
      // it only changes once unsaved changes are confirmed.
      confirmedDailyScheduleType: activeDailyScheduleType,
      dailySchedules: [],
      dailyScheduleTypes,
      date,
      // Data of each department column, loaded for all of them at once (see loadDepartments).
      departmentData: {},
      employeeSelectorFilter: [{ op: 'in', prop: 'classification', value: ['ops_management'] }],
      filters: getDefaultFilters(),
      hasChanges: false,
      loadingShareDialog: true,
      openedPanel: {
        name: undefined,
        owner: null
      },
      openShiftCount: 0,
      panels: [], // Opened right side panels
      // Active schedule to restore after a column of a department group changed it.
      savedActiveSchedule: null,
      shareDialogOpened: false,
      shareOptions: getDailyScheduleDefaultOptions(
        _.get(this.$store.state.org.settings, 'scheduling.dailySchedule.templates.pdf', null)
      ),
      shareWithDepartments,
      shareWithAdditionalRecipients: {
        recipients: [],
        status: 'ready' // null, pending, in_progress, success, failed
      },
      sharingSummaryType: null,
      sharingSummaryState: SHARING_SUMMARY_READY,
      showHelp: false,
      showDatePicker: false,
      today: moment().format(DATE_FORMAT)
    };
  },
  computed: {
    actionStyles () {
      const defaultButtonClasses = ['grey', 'lighten-2', 'mr-2'];
      const defaultIconClasses = ['grey--text', 'text--darken-3'];
      const styles = {
        filters: {
          button: {
            classes: defaultButtonClasses.concat(['filters'])
          },
          icon: {
            classes: defaultIconClasses
          }
        },
        viewOpenShift: {
          button: {
            classes: defaultButtonClasses.concat(['view-open-shift'])
          },
          icon: {
            classes: defaultIconClasses
          }
        }
      };

      if (this.hasFilters) {
        styles.filters = {
          button: {
            classes: ['primary', 'lighten-2', 'mr-2', 'filters']
          },
          icon: {
            classes: ['white--text']
          }
        };
      }

      const openedPanelName = this.pagePanelName;
      if (openedPanelName && styles[openedPanelName]) {
        styles[openedPanelName].button.classes = ['primary', 'mr-2', openedPanelName];
        styles[openedPanelName].icon.classes = ['white--text'];
      }

      return styles;
    },
    activeDepartments () {
      return this.$store.getters['org/getActiveDepartmentGroup']();
    },
    canEdit () {
      return this.$can('edit', 'dailySchedule');
    },
    dateFormatString () {
      return this.$store.getters['org/getDateFormatLongWithDoW']();
    },
    dateFormatStringLong () {
      return this.$store.getters['org/getDateTimeFormatLong']();
    },
    failedSharingSummary () {
      if (this.shareWithAdditionalRecipients.status === 'failed') {
        return true;
      }
      for (let i = 0, count = this.shareWithDepartments.length; i < count; i++) {
        const departmentInfo = this.shareWithDepartments[i];
        if (departmentInfo.status === 'failed') {
          return true;
        }
      }
      return false;
    },
    hasFilters () {
      const diff = DeepDiff(getDefaultFilters(), this.filters) || [];
      return diff.length > 0;
    },
    isGroup () {
      return this.activeDepartments.length > 1;
    },
    pagePanelName () {
      return this.openedPanel.owner === PAGE_PANEL_OWNER ? this.openedPanel.name : undefined;
    },
    selectedDepartmentsToShare () {
      return _.sum(_.values(this.shareCount));
    },
    selectorsStyle () {
      const style = {};
      if (this.$vuetify.breakpoint.width < 530) {
        style['max-width'] = '120px';
      } else if (this.$vuetify.breakpoint.width < 600) {
        style['max-width'] = '150px';
      } else {
        style['max-width'] = '190px';
      }
      return style;
    },
    shareCount () {
      const shareCount = {};
      for (let i = 0, count = this.dailyScheduleTypes.length; i < count; i++) {
        const id = this.dailyScheduleTypes[i].id;
        shareCount[id] = _.filter(this.shareWithDepartments, (item) => item.dailySchedules[id].send).length;
      }
      return shareCount;
    },
    shareSummaryHeaders () {
      const headers = [
        { sortable: false, text: '', value: 'department', width: 170 }
      ];
      for (let i = 0, count = this.dailyScheduleTypes.length; i < count; i++) {
        headers.push({
          sortable: false,
          text: this.dailyScheduleTypes[i].name,
          value: 'dailySchedule',
          id: this.dailyScheduleTypes[i].id
        });
      }
      return headers;
    },
    shiftTypes () {
      return this.$store.state.org.shiftTypes.reduce(
        (obj, shiftType) => (obj[shiftType.id] = shiftType, obj), // eslint-disable-line no-return-assign, no-sequences
        {}
      );
    },
    sidePanels () {
      const helpPanel = [{
        id: _.uniqueId(),
        component: Help,
        props: {},
        events: {
          close: () => {
            this.toggleHelpPanel();
          }
        }
      }];
      return this.showHelp ? helpPanel : this.panels;
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit(
      'remove_ws_update_callback',
      'daily_schedule_page',
      { root: true }
    );
    next();
  },
  watch: {
    activeDepartments (departments, previousDepartments) {
      if (_.isEqual(_.map(departments, 'id'), _.map(previousDepartments, 'id'))) {
        return;
      }
      this.closeAllPanels();
      this.hasChanges = false;
      this.restoreActiveSchedule();
      this.resetShareDialog();
      this.updateOpenShiftCount();
      this.loadDepartments();
    },
    confirmedDailyScheduleType () {
      this.loadDailySchedules();
    },
    date () {
      this.showDatePicker = false;
      this.resetShareDialog();
      this.updateOpenShiftCount();
      this.$store.commit('scheduling/set_daily_schedule_filters', { date: this.date });
      this.loadDepartments();
    },
    openedPanel (openedPanel) {
      const { name, owner } = openedPanel;
      if (!name) {
        this.closeAllPanels();
      } else if (owner === PAGE_PANEL_OWNER) {
        switch (name) {
          case 'filters':
            this.openFiltersPanel();
            break;
          case 'viewOpenShift':
            this.openOpenShiftsListPanel();
            break;
        }
      } else {
        const column = _.find(this.getColumns(), (c) => c.departmentId === owner);
        if (column) {
          column.openPanel(name);
        }
      }
    },
    shareDialogOpened () {
      this.sharingSummaryState = this.SHARING_SUMMARY_READY;
      for (let i = 0, count = this.shareWithDepartments.length; i < count; i++) {
        this.shareWithDepartments[i].status = null;
      }
      if (this.shareDialogOpened) {
        this.loadShareDialog();
      }
    }
  },
  created () {
    // Only the latest response is applied when the date or departments change while loading.
    this.departmentLoadSequence = 0;
    this.openShiftCountSequence = 0;
    this.shareDialogSequence = 0;
    // Schedules of the departments from the last load, kept while loading another daily schedule type.
    // Null while they are loading or when they failed to load.
    this.loadedSchedules = null;
  },
  beforeDestroy () {
    this.restoreActiveSchedule();
  },
  mounted () {
    this.loadDepartments();
    this.updateOpenShiftCount();
    this.$store.commit(
      'add_ws_update_callback',
      { name: 'daily_schedule_page', callback: this.onWsUpdate },
      { root: true }
    );
  },
  methods: {
    has: _.has,
    closeAllPanels () {
      this.panels.splice(0, this.panels.length);
      this.setOpenedPanel(undefined);
    },
    closeLastPanel () {
      this.panels.pop();
    },
    closePanels (start, count) {
      this.panels.splice(start, count);
    },
    // This function is added mainly for easy of mocking during in unit tests.
    dispatch (action, payload) {
      return new Promise((resolve, reject) => {
        this.$store.dispatch(action, payload).then(response => {
          resolve(response);
        }).catch(error => {
          reject(error);
        });
      });
    },
    generatePDF (department, dailySchedule, dailyScheduleType, shifts, usersInfo) {
      return new Promise((resolve, reject) => {
        try {
          const DailySchedulePDFTemplate = getDailyScheduleTemplate(
            _.get(this.$store.state.org.settings, 'scheduling.dailySchedule.templates.pdf', null)
          );
          const sharedBy = this.$store.state.org.employees[this.$store.state.account.userId].fullName;
          const dailySchedulePDF = new DailySchedulePDFTemplate(
            dailySchedule,
            this.date,
            department,
            dailyScheduleType,
            this.$store,
            (...args) => this.$t(...args),
            (...args) => this.$tc(...args),
            {
              getEmployees: (options) => {
                const {
                  filters = [],
                  groupBy = [],
                  orderBy = []
                } = options;
                const filteredEmployees = filterData(_.filter(_.values(this.$store.state.org.employees), (e) => e.departmentId === department.id && e.state === ACCOUNT_STATE.active), filters);
                if (groupBy.length > 0) {
                  return groupData(filteredEmployees, groupBy, (data) => sortData(data, orderBy));
                } else {
                  return sortData(filteredEmployees, orderBy);
                }
              },
              getShifts: (options) => {
                const {
                  filters = [],
                  groupBy = [],
                  orderBy = []
                } = options;
                const filteredShifts = filterData(shifts, filters);
                if (groupBy.length > 0) {
                  return groupData(filteredShifts, groupBy, (data) => sortAndGroupShifts(data, orderBy, usersInfo));
                } else {
                  return sortAndGroupShifts(filteredShifts, orderBy, usersInfo);
                }
              }
            },
            this
          );

          dailySchedulePDF.setHeader(
            `${this.$t('labels.page')} {currentPage}/{pageCount}`,
            [
              this.$t('labels.sharedBy', { name: sharedBy }),
              moment().format(this.dateFormatStringLong)
            ]
          );
          dailySchedulePDF.generate(this.shareOptions);
          dailySchedulePDF.getBase64().then((base64) => {
            resolve({
              base64,
              dailySchedulePDF
            });
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    /**
     * Gets the department columns currently displayed.
     * @returns {Array} DepartmentDailySchedule components
     */
    getColumns () {
      return this.$refs.columns || [];
    },
    getUserInitials (userId) {
      const user = this.$store.state.org.employees[userId];
      return user.firstName[0] + user.lastName[0];
    },
    goToToday () {
      this.date = moment().format(DATE_FORMAT);
    },
    hasProps (data, props) {
      return _.has(data, props);
    },
    /**
     * Checks if a load of the departments' data was replaced by a newer one, or the page is gone.
     * @param {number} load Load sequence number
     * @returns {Boolean}
     */
    isStaleDepartmentLoad (load) {
      return this._isDestroyed || load !== this.departmentLoadSequence;
    },
    /**
     * Loads the daily schedules (census, notes, state) of the current daily schedule type for every department shown.
     * Shifts don't need to be reloaded since they were retrieved for all shift types.
     */
    loadDailySchedules () {
      if (!this.canEdit) {
        return;
      }
      if (!this.loadedSchedules) {
        // Shifts are still loading or failed to load, so load everything again for the new daily schedule type.
        this.loadDepartments();
        return;
      }
      const load = ++this.departmentLoadSequence;
      const deptIds = _.map(this.activeDepartments, 'id');
      this.departmentData = {};
      this.closeAllPanels();
      this.dispatch('scheduling/retrieveDailySchedules', {
        dept_ids: deptIds.join(','),
        type_id: this.confirmedDailyScheduleType.id,
        for_date: this.date,
        daily_schedule_load: `page-${load}`
      }).then((dailySchedules) => {
        if (this.isStaleDepartmentLoad(load)) {
          return;
        }
        const dailySchedulesByDepartment = _.mapValues(_.groupBy(dailySchedules, 'departmentId'), _.head);
        // The columns keep their shifts since the schedules are the same.
        this.departmentData = _.mapValues(this.loadedSchedules, (schedule, deptId) => ({
          dailySchedule: dailySchedulesByDepartment[deptId] || null,
          schedule
        }));
      }).catch((error) => {
        if (this.isStaleDepartmentLoad(load)) {
          return;
        }
        this.onDepartmentsLoadFailed(deptIds, error);
      });
    },
    /**
     * Loads the data of every department shown, with one request for each kind of data instead of one per
     * department, and passes each column its department's data. Only the latest load is applied.
     */
    loadDepartments () {
      const load = ++this.departmentLoadSequence;
      const deptIds = _.map(this.activeDepartments, 'id');
      this.loadedSchedules = null;
      this.departmentData = {};
      this.closeAllPanels();
      if (deptIds.length === 0) {
        // No department to show.
        return;
      }
      this.dispatch('scheduling/retrieveDailyScheduleDataForDepartments', {
        date: this.date,
        deptIds,
        isStale: () => this.isStaleDepartmentLoad(load),
        // Tags the requests so they aren't cancelled as duplicates of an older load's.
        requestTag: `page-${load}`,
        // Only users who can edit daily schedules see their census, notes and state.
        typeId: this.canEdit ? this.confirmedDailyScheduleType.id : null
      }).then((data) => {
        if (this.isStaleDepartmentLoad(load)) {
          return;
        }
        this.loadedSchedules = _.mapValues(data, 'schedule');
        this.departmentData = data;
      }).catch((error) => {
        if (this.isStaleDepartmentLoad(load)) {
          return;
        }
        this.onDepartmentsLoadFailed(deptIds, error);
      });
    },
    loadNewContent (contentCallback, callbackParams, cancelCallback) {
      if (this.hasChanges) {
        this.$dialog.confirm(getUnsavedChangesDialogProps(this)).then(() => {
          if (cancelCallback) {
            cancelCallback();
          }
        }).catch(() => {
          this.hasChanges = false;
          this.$store.commit('unmark_all_unsaved_changes');
          const params = callbackParams || [];
          contentCallback(...params);
        });
      } else {
        const params = callbackParams || [];
        contentCallback(...params);
      }
    },
    loadShareDialog () {
      const request = ++this.shareDialogSequence;
      this.loadingShareDialog = true;
      const dailyScheduleCriteria = {
        for_date: this.date
      };
      this.dispatch('scheduling/retrieveDailySchedules', dailyScheduleCriteria).then((response) => {
        if (request === this.shareDialogSequence) {
          this.updateLastSharedWith(response);
        }
      }).catch(() => {}).finally(() => {
        if (request === this.shareDialogSequence) {
          this.loadingShareDialog = false;
        }
      });
    },
    moment,
    nextDay () {
      this.date = moment(this.date).add(1, 'day').format(DATE_FORMAT);
    },
    onDailyScheduleTypeChange (type) {
      this.loadNewContent(this.setActiveDailyScheduleType, [type], () => {
        this.activeDailyScheduleType = _.cloneDeep(this.previousActiveDailyScheduleType);
      });
    },
    /**
     * Shows that the departments' data couldn't be loaded, once for all columns.
     * @param {Array} deptIds Department IDs
     * @param {Error} error Error
     */
    onDepartmentsLoadFailed (deptIds, error) {
      this.departmentData = _.fromPairs(deptIds.map((deptId) => [deptId, { failed: true }]));
      if (error instanceof RequestCanceledError) {
        // Not a failure: the same request is already pending.
        return;
      }
      showStatus({
        text: this.$t('descriptions.scheduleRetrievalFail'),
        type: 'error',
        data: {
          error: _.get(error, 'response.data')
        }
      });
    },
    onOpenShiftUpdateReceived (event) {
      const { action } = JSON.parse(event.data);
      if (['deleted', 'closed', 'ended'].includes(action)) {
        this.updateOpenShiftCount();
      }
    },
    onShiftUpdateReceived (event) {
      const { action, assignee_id: assigneeId, date, id } = JSON.parse(event.data);
      const columns = this.getColumns();
      const affectsColumns = _.some(columns, (column) => column.coversDate(date) || column.findShiftInGrid(id));
      if (!affectsColumns || !_.has(this.$store.state.org.employees, [assigneeId])) {
        return;
      }
      // Each column decides what to do: a shift moved to another department leaves its column and joins the other.
      switch (action) {
        case 'create':
        case 'update':
          // Retrieved once for all columns.
          this.dispatch('scheduling/retrieveShift', id).then(shift => {
            shift.type = 'shift';
            shift.date = moment(shift.date).toDate();
            for (const column of this.getColumns()) {
              column.applyShiftUpdate(shift);
            }
          }).catch(() => {});
          break;
        case 'delete':
          for (const column of columns) {
            column.applyShiftDelete(id);
          }
          break;
      }
    },
    onWsUpdate (eventInfo) {
      const data = JSON.parse(eventInfo.data);
      const contentType = data.content_type;
      switch (contentType) {
        case CONTENT_TYPES.openShift:
          this.onOpenShiftUpdateReceived(eventInfo);
          break;
        case CONTENT_TYPES.shift:
          this.onShiftUpdateReceived(eventInfo);
          break;
      }
    },
    openCreateOpenShiftPanel () {
      this.showPanel(() => {
        return {
          component: CreateOpenShift,
          props: {
            allowEditingDepartment: true,
            date: this.date,
            departmentId: this.activeDepartments[0].id,
            jobTypeId: _.get(this.getColumns(), [0, 'associatedJobTypes', 0], null),
            shiftTypeId: this.$store.getters['org/getDailyScheduleTypeById'](this.activeDailyScheduleType.id, 'shiftTypes')[0]
          },
          events: {
            close: () => {
              this.openOpenShiftsListPanel();
            },
            created: (openShift) => {
              this.openShiftCount++;
              this.openOpenShiftDetailsPanel(openShift, true);
            }
          }
        };
      }, [], false);
    },
    openFiltersPanel () {
      this.showPanel(() => {
        return {
          props: {
            eventFilters: _.cloneDeep(_.get(this.filters, 'event', {})),
            shiftFilters: _.cloneDeep(_.get(this.filters, 'shift', {})),
            userFilters: _.cloneDeep(_.get(this.filters, 'user', {}))
          },
          component: Filters,
          events: {
            close: () => {
              this.setOpenedPanel(undefined);
              return true;
            },
            apply: (filters) => {
              this.filters = filters;
              this.refreshPanels();
            }
          }
        };
      }, [], true);
    },
    openOpenShiftDetailsPanel (openShift, replaceLastPanel = false) {
      let openShiftCopy = _.cloneDeep(openShift);
      const data = () => {
        return {
          component: OpenShiftDetails,
          props: {
            id: openShiftCopy.id
          },
          events: {
            close: () => {
              this.openOpenShiftsListPanel();
            }
          }
        };
      };
      if (replaceLastPanel) {
        this.updatePanel(this.panels.length - 1, data, []);
      } else {
        this.showPanel(data, [], false);
      }
    },
    openOpenShiftsListPanel () {
      this.showPanel(() => {
        return {
          component: OpenShiftsList,
          props: {
            date: this.date,
            departmentIds: _.map(this.activeDepartments, 'id')
          },
          events: {
            close: () => {
              this.setOpenedPanel(undefined);
              return true;
            },
            create: () => {
              this.openCreateOpenShiftPanel();
            },
            'open-details': (openShift) => {
              this.openOpenShiftDetailsPanel(openShift, false);
            }
          }
        };
      }, [], true);
    },
    preparePanelData (panelDataCallback, params) {
      const panelData = panelDataCallback(...params);
      if (panelData) {
        const closeCallback = _.get(panelData, ['events', 'close']);
        panelData.events.close = () => {
          if (closeCallback) {
            if (closeCallback()) {
              this.closeLastPanel();
            }
          } else {
            this.closeLastPanel();
          }
        };
      }
      return panelData;
    },
    previousDay () {
      this.date = moment(this.date).subtract(1, 'day').format(DATE_FORMAT);
    },
    refreshPanels (count) {
      const len = count || this.panels.length;
      for (let i = 0; i < len; i++) {
        if (this.panels[i]) {
          this.updatePanel(i, this.panels[i].panelDataCallback, this.panels[i].params);
        }
      }
    },
    resetShareDialog () {
      this.sharingSummaryState = this.SHARING_SUMMARY_READY;
      this.loadingShareDialog = true;
      const activeDepartmentIds = _.map(this.activeDepartments, 'id');
      for (let i = 0, count = this.shareWithDepartments.length; i < count; i++) {
        const dailySchedules = this.shareWithDepartments[i].dailySchedules;
        this.shareWithDepartments[i].status = null;
        for (let id in dailySchedules) {
          dailySchedules[id].send = activeDepartmentIds.includes(this.shareWithDepartments[i].id) && id == this.activeDailyScheduleType.id;
          dailySchedules[id].lastShared = '';
          dailySchedules[id].lastSharedDetails = '';
        }
      }
    },
    retryShareSummary () {
      this.sharingSummaryState = this.SHARING_SUMMARY_IN_PROGRESS;
      let requests = Promise.resolve();
      const dailySchedules = [];
      for (let i = 0, count = this.shareWithDepartments.length; i < count; i++) {
        const departmentInfo = this.shareWithDepartments[i];
        if (departmentInfo.status === 'failed') {
          const typeIds = [];
          for (let dailyScheduleTypeId in departmentInfo.dailySchedules) {
            if (departmentInfo.dailySchedules[dailyScheduleTypeId].send) {
              typeIds.push(departmentInfo.dailySchedules[dailyScheduleTypeId].id);
            }
          }
          if (typeIds.length > 0) {
            departmentInfo.status = 'pending';
            requests = requests.then(() => {
              return this.shareDailyScheduleWithDepartment(departmentInfo.id, typeIds).then((ds) => {
                if (this.sharingSummaryType === this.SHARING_SUMMARY_EMAIL_TYPE) {
                  dailySchedules.push(...ds);
                }
              }).catch(() => {});
            });
          }
        }
      }
      if (this.sharingSummaryType === this.SHARING_SUMMARY_EMAIL_TYPE && this.shareWithAdditionalRecipients.recipients.length > 0) {
        this.shareWithAdditionalRecipients.status = 'pending';
        requests = requests.then(() => {
          return this.shareDailyScheduleWithRecipients(dailySchedules).catch(() => {});
        });
      } else {
        this.shareWithAdditionalRecipients.status = this.SHARING_SUMMARY_READY;
      }
      requests.finally(() => {
        this.sharingSummaryState = this.SHARING_SUMMARY_FINISHED;
      });
    },
    /**
     * Restores the active schedule saved by setActiveScheduleId.
     */
    restoreActiveSchedule () {
      if (this.savedActiveSchedule) {
        this.$store.commit('scheduling/set_active_schedule_id', this.savedActiveSchedule.id);
        this.savedActiveSchedule = null;
      }
    },
    /**
     * Sets the active schedule, which request approvals update. With a department group, the previous active
     * schedule is restored when leaving the page so other pages keep showing the active department's schedule.
     * @param {Number} scheduleId Schedule ID
     */
    setActiveScheduleId (scheduleId) {
      if (this.isGroup && !this.savedActiveSchedule) {
        this.savedActiveSchedule = { id: this.$store.state.scheduling.activeScheduleId };
      }
      this.$store.commit('scheduling/set_active_schedule_id', scheduleId);
    },
    setActiveDailyScheduleType (type) {
      // The departments' daily schedules are reloaded when the confirmed type changes (see loadDailySchedules).
      this.previousActiveDailyScheduleType = _.cloneDeep(type);
      this.activeDailyScheduleType = type;
      this.confirmedDailyScheduleType = type;
      this.resetShareDialog();
    },
    setDate (date) {
      this.date = date;
    },
    /**
     * Sets the panel that is open. Columns own their panels; the page owns the rest.
     * @param {string} name Panel name. Undefined closes all panels.
     * @param {string|Number} owner Department ID of the column owning the panel.
     */
    setOpenedPanel (name, owner = PAGE_PANEL_OWNER) {
      if (!name && !this.openedPanel.name) {
        return;
      }
      if (name !== this.openedPanel.name || owner !== this.openedPanel.owner) {
        this.openedPanel = { name, owner };
      }
    },
    setPanelName (panel, owner = PAGE_PANEL_OWNER) {
      if (this.hasChanges) {
        this.$dialog.confirm(getUnsavedChangesDialogProps(this)).then(() => {}).catch(() => {
          this.hasChanges = false;
          this.$store.commit('unmark_all_unsaved_changes');
          this.setOpenedPanel(panel, owner);
        });
      } else {
        this.setOpenedPanel(panel, owner);
      }
    },
    shareDailySchedulePayload (departmentId, typeId, dailySchedules) {
      return new Promise((resolve, reject) => {
        const dailyScheduleType = this.dailyScheduleTypes.find((t) => t.id === typeId);
        const shiftsCriteria = {
          dept_id: departmentId,
          flex_on: 'false',
          date_or_payroll_date_on: this.date,
          shift_type_ids: dailyScheduleType.shiftTypes.join(',')
        };
        this.dispatch('scheduling/retrieveShifts', shiftsCriteria).then(shifts => {
          const department = _.find(this.$store.state.org.departments, (d) => d.id === departmentId);
          const dailySchedule = _.find(this.dailySchedules, (ds) => ds.typeId === typeId && ds.departmentId === departmentId && ds.date === this.date);
          const processedShifts = [];
          for (let i = 0, count = shifts.length; i < count; i++) {
            if (shifts[i].payrollDate && shifts[i].payrollDate !== this.date) {
              continue;
            }
            processedShifts.push(shifts[i]);
          }
          if (processedShifts.length === 0) {
            this.generatePDF(department, dailySchedule, dailyScheduleType, processedShifts, {}).then((data) => {
              dailySchedules.push({
                dept_id: departmentId,
                type_id: typeId,
                ...data
              });
              resolve(dailySchedules);
            }).catch((error) => {
              reject(error);
            });
          } else {
            const includeAssigneeIds = [];
            const userInfo = {};
            let jobCount = 1;
            const jobTypeWeights = _.get(department, ['settings', 'staffNeeded'], []).reduce(
              (obj, staffNeeded) => {
                const jobTypes = _.get(staffNeeded, 'jobTypes', []);
                for (let j = 0, typeCount = jobTypes.length; j < typeCount; j++) {
                  obj[jobTypes[j]] = jobCount;
                  jobCount++;
                }
                return obj;
              },
              {}
            );
            for (let i = 0, count = processedShifts.length; i < count; i++) {
              processedShifts[i].assignee = this.$store.state.org.employees[processedShifts[i].assigneeId];
              processedShifts[i].assignee.jobTypeWeight = jobTypeWeights[_.get(processedShifts[i], 'assignee.jobTypeId', 0)] || 1000;
              processedShifts[i].type = this.shiftTypes[processedShifts[i].typeId];
              includeAssigneeIds.push(processedShifts[i].assigneeId);
              if (!userInfo[processedShifts[i].assigneeId]) {
                userInfo[processedShifts[i].assigneeId] = {
                  hours: {
                    daily: {},
                    weekly: 0
                  },
                  last: {
                    canceled: null,
                    float: null,
                    overtime: null
                  }
                };
              }
            }

            const requests = [];
            const requestsCallbacks = [];

            if (this.shareOptions.loadExtraShifts) {
              let startOfWeek = calculateStartOfWeek(this.date, this.$store.state.org.settings.scheduling.startOfWeek);
              const weeklyShiftsCriteria = {
                dept_id: departmentId,
                flex_on: 'false',
                between: [startOfWeek.format(DATE_FORMAT), startOfWeek.add(6, 'd').format(DATE_FORMAT)].join(','),
                include_assignee_ids: includeAssigneeIds.join(',')
              };
              requests.push(this.dispatch('scheduling/retrieveShifts', weeklyShiftsCriteria));
              requestsCallbacks.push((shifts) => {
                prepareShiftHours(this.$store, shifts, userInfo);
              });
            }
            if (this.shareOptions.loadLastDates) {
              requests.push(this.dispatch('scheduling/retrieveLastShifts', {
                type: 'float',
                before: this.date,
                assignee_ids: includeAssigneeIds.join(',')
              }));
              requestsCallbacks.push((shifts) => {
                prepareLastDates(shifts, userInfo, 'float');
              });
              requests.push(this.dispatch('scheduling/retrieveLastShifts', {
                type: 'canceled',
                before: this.date,
                assignee_ids: includeAssigneeIds.join(',')
              }));
              requestsCallbacks.push((shifts) => {
                prepareLastDates(shifts, userInfo, 'canceled');
              });
              requests.push(this.dispatch('scheduling/retrieveLastShifts', {
                type: 'overtime',
                before: this.date,
                assignee_ids: includeAssigneeIds.join(',')
              }));
              requestsCallbacks.push((shifts) => {
                prepareLastDates(shifts, userInfo, 'overtime');
              });
            }

            Promise.all(requests).then((response) => {
              for (let i = 0, count = response.length; i < count; i++) {
                requestsCallbacks[i](response[i]);
              }
              this.generatePDF(department, dailySchedule, dailyScheduleType, processedShifts, userInfo).then((data) => {
                dailySchedules.push({
                  dept_id: departmentId,
                  type_id: typeId,
                  ...data
                });
                resolve(dailySchedules);
              }).catch((error) => {
                reject(error);
              });
            }).catch((error) => {
              reject(error);
            });
          }
        }).catch((error) => {
          reject(error);
        });
      });
    },
    shareDailyScheduleWithRecipients (dailySchedules) {
      return new Promise((resolve, reject) => {
        this.shareWithAdditionalRecipients.status = 'in_progress';
        this.dispatch('scheduling/shareDailySchedule', {
          date: this.date,
          daily_schedules: dailySchedules,
          recipients: this.shareWithAdditionalRecipients.recipients
        }).then((response) => {
          this.shareWithAdditionalRecipients.status = 'success';
          resolve();
        }).catch((error) => {
          this.shareWithAdditionalRecipients.status = 'failed';
          reject(error);
        });
      });
    },
    shareDailyScheduleWithDepartment (departmentId, typeIds) {
      return new Promise((resolve, reject) => {
        let requests = Promise.resolve([]);
        const departmentInfo = _.find(this.shareWithDepartments, (d) => d.id === departmentId);
        departmentInfo.status = 'in_progress';
        for (let i = 0, count = typeIds.length; i < count; i++) {
          requests = requests.then((dailySchedules) => {
            return this.shareDailySchedulePayload(departmentId, typeIds[i], dailySchedules);
          });
        }
        requests.then((dailySchedules) => {
          const payload = {
            date: this.date,
            daily_schedules: dailySchedules.map((ds) => {
              return {
                dept_id: ds.dept_id,
                type_id: ds.type_id,
                pdf: ds.base64
              };
            })
          };
          switch (this.sharingSummaryType) {
            case this.SHARING_SUMMARY_DOWNLOAD_TYPE:
              try {
                for (const ds of dailySchedules) {
                  ds.dailySchedulePDF.download();
                }
                departmentInfo.status = 'success';
                resolve();
              } catch (error) {
                departmentInfo.status = 'failed';
                reject(error);
              }
              break;
            case this.SHARING_SUMMARY_EMAIL_TYPE:
              this.dispatch('scheduling/shareDailySchedule', payload).then((response) => {
                departmentInfo.status = 'success';
                this.updateLastSharedWith(response.dailySchedules);
                for (let dailySchedule of response.dailySchedules) {
                  if (dailySchedule.typeId === this.activeDailyScheduleType.id) {
                    const column = _.find(this.getColumns(), (c) => c.departmentId === dailySchedule.departmentId);
                    if (column) {
                      column.updateData(dailySchedule);
                    }
                  }
                }
                resolve(payload.daily_schedules);
              }).catch((error) => {
                departmentInfo.status = 'failed';
                reject(error);
              });
          }
        }).catch(error => {
          departmentInfo.status = 'failed';
          reject(error);
        });
      });
    },
    downloadSummary () {
      if (this.selectedDepartmentsToShare && this.sharingSummaryState !== this.SHARING_SUMMARY_IN_PROGRESS) {
        this.sharingSummaryType = this.SHARING_SUMMARY_DOWNLOAD_TYPE;
        this.sharingSummaryState = this.SHARING_SUMMARY_IN_PROGRESS;
        let requests = Promise.resolve();
        for (let i = 0, count = this.shareWithDepartments.length; i < count; i++) {
          const departmentInfo = this.shareWithDepartments[i];
          const typeIds = [];
          for (let dailyScheduleTypeId in departmentInfo.dailySchedules) {
            if (departmentInfo.dailySchedules[dailyScheduleTypeId].send) {
              typeIds.push(departmentInfo.dailySchedules[dailyScheduleTypeId].id);
            }
          }
          if (typeIds.length > 0) {
            departmentInfo.status = 'pending';
            requests = requests.then(() => {
              return this.shareDailyScheduleWithDepartment(departmentInfo.id, typeIds).catch(() => {});
            });
          }
        }
        requests.finally(() => {
          this.sharingSummaryState = this.SHARING_SUMMARY_FINISHED;
        });
      }
    },
    emailSummary () {
      if (this.selectedDepartmentsToShare && this.sharingSummaryState !== this.SHARING_SUMMARY_IN_PROGRESS) {
        this.sharingSummaryType = this.SHARING_SUMMARY_EMAIL_TYPE;
        this.sharingSummaryState = this.SHARING_SUMMARY_IN_PROGRESS;
        let requests = Promise.resolve();
        const dailySchedules = [];
        for (let i = 0, count = this.shareWithDepartments.length; i < count; i++) {
          const departmentInfo = this.shareWithDepartments[i];
          const typeIds = [];
          for (let dailyScheduleTypeId in departmentInfo.dailySchedules) {
            if (departmentInfo.dailySchedules[dailyScheduleTypeId].send) {
              typeIds.push(departmentInfo.dailySchedules[dailyScheduleTypeId].id);
            }
          }
          if (typeIds.length > 0) {
            departmentInfo.status = 'pending';
            requests = requests.then(() => {
              return this.shareDailyScheduleWithDepartment(departmentInfo.id, typeIds).then((ds) => {
                dailySchedules.push(...ds);
              }).catch(() => {});
            });
          }
        }
        if (this.shareWithAdditionalRecipients.recipients.length > 0) {
          this.shareWithAdditionalRecipients.status = 'pending';
          requests = requests.then(() => {
            return this.shareDailyScheduleWithRecipients(dailySchedules).catch(() => {});
          });
        } else {
          this.shareWithAdditionalRecipients.status = this.SHARING_SUMMARY_READY;
        }
        requests.finally(() => {
          this.sharingSummaryState = this.SHARING_SUMMARY_FINISHED;
        });
      }
    },
    shareWithAllDepartments (dailyScheduleTypeId) {
      for (let i = 0, count = this.shareWithDepartments.length; i < count; i++) {
        this.shareWithDepartments[i].dailySchedules[dailyScheduleTypeId].send = true;
      }
    },
    shareWithZeroDepartments (dailyScheduleTypeId) {
      for (let i = 0, count = this.shareWithDepartments.length; i < count; i++) {
        this.shareWithDepartments[i].dailySchedules[dailyScheduleTypeId].send = false;
      }
    },
    showPanel (panelDataCallback, params, resetPanels) {
      const show = () => {
        if (resetPanels && this.panels.length > 0) {
          this.closePanels(1, this.panels.length);
          this.updatePanel(0, panelDataCallback, params);
        } else {
          const panelData = this.preparePanelData(panelDataCallback, params);
          if (panelData) {
            panelData.id = _.uniqueId();
            panelData.panelDataCallback = panelDataCallback;
            panelData.params = params;
            this.panels.push(_.cloneDeep(panelData));
          }
        }
      };
      if (this.hasChanges) {
        this.$dialog.confirm(getUnsavedChangesDialogProps(this)).then(() => {}).catch(() => {
          this.hasChanges = false;
          this.$store.commit('unmark_all_unsaved_changes');
          show();
        });
      } else {
        show();
      }
    },
    toggleHelpPanel () {
      this.showHelp = !this.showHelp;
    },
    toggleDailyScheduleShare (item, header) {
      if (this.sharingSummaryState === this.SHARING_SUMMARY_READY) {
        item.dailySchedules[header.id].send = !item.dailySchedules[header.id].send;
      }
    },
    updateAdditionalRecipients (recipients) {
      this.shareWithAdditionalRecipients.recipients = recipients;
    },
    updateLastSharedWith (dailySchedules) {
      for (let i = 0, count = dailySchedules.length; i < count; i++) {
        if (dailySchedules[i].sharedById && dailySchedules[i].sharedOn) {
          const matchedItem = _.find(this.shareWithDepartments, (item) => item.id === dailySchedules[i].departmentId);
          if (matchedItem && matchedItem.dailySchedules[dailySchedules[i].typeId]) {
            const shortPlaceholders = {
              name: this.getUserInitials(dailySchedules[i].sharedById)
            };
            const datailsPlaceholders = {
              name: this.$store.state.org.employees[dailySchedules[i].sharedById].fullName,
              date: moment(dailySchedules[i].sharedOn).format(this.dateFormatString),
              time: moment(dailySchedules[i].sharedOn).format('h:mm a')
            };
            matchedItem.dailySchedules[dailySchedules[i].typeId].lastShared = this.$t('descriptions.summaryLastShared', shortPlaceholders);
            matchedItem.dailySchedules[dailySchedules[i].typeId].lastSharedDetails = this.$t('descriptions.summaryLastSharedDetails', datailsPlaceholders);
          }
        }
        const idx = _.findIndex(this.dailySchedules, (ds) => ds.id === dailySchedules[i].id);
        if (idx >= 0) {
          this.dailySchedules.splice(idx, 1, dailySchedules[i]);
        } else {
          this.dailySchedules.push(dailySchedules[i]);
        }
      }
    },
    updateOpenShiftCount () {
      return new Promise((resolve, reject) => {
        const queryParams = {
          date: this.date,
          department_ids: _.map(this.activeDepartments, 'id').join(','),
          open: 'true',
          self_schedule_only: 'false'
        };
        const request = ++this.openShiftCountSequence;
        this.dispatch('scheduling/retrieveOpenShiftsCount', queryParams).then(count => {
          if (request === this.openShiftCountSequence) {
            this.openShiftCount = count;
          }
          resolve(this.openShiftCount);
        }).catch(() => {
          resolve(0);
        });
      });
    },
    updatePanel (panelIdx, panelDataCallback, params) {
      const panel = this.panels[panelIdx];
      const panelData = this.preparePanelData(panelDataCallback, params);
      if (panelData) {
        panelData.id = panel.id;
        panelData.panelDataCallback = panelDataCallback;
        panelData.params = params;
        this.panels.splice(panelIdx, 1, _.cloneDeep(panelData));
      }
    }
  }
};
</script>

<style lang="scss">
.container.daily-schedule {
  height: 100%;
  margin-left: 0px;
  width: 1310px;

  // Several departments use the whole width to fit more columns.
  &.group {
    width: 100%;
  }

  .department-columns.group {
    overflow-x: auto;
    white-space: nowrap;

    .department-daily-schedule {
      white-space: normal;
    }
  }

  .actions {
    .v-btn {
      border-radius: 18px !important;
      height: 36px !important;
      min-width: 36px !important;
      width: 36px !important;

      &::before {
        opacity: 0 !important;
      }
    }
  }

  .date-navigation {
    // Share and finalize show a label on large screens, so they can't use the round icon button size.
    .v-btn.v-btn--text {
      width: auto !important;
    }
  }

  .attendance-chip {
    display: inline-block;
    text-align: center;
    width: 80px;
  }
  .body-container {
    background-color: white;
    border-color: map-get($grey, 'lighten-3');
    border-style: solid;
    border-width: 1px;

    &.actions {
      border-bottom: none;
    }
  }
  .categories {
    .shift-column {
      padding-left: 26px;
    }
    tr {
      th:nth-child(2) {
        padding: 0px;
        text-align-last: center;
      }
      td:nth-child(2) {
        background-color: #F4F4F4;
        padding: 0px;
      }
    }
    td {
      position: relative;
    }
    .read-only-overlay {
      background: rgba(224, 224, 224, 0.3);
      height: 100%;
      left: 220px;
      pointer-events: none;
      position: absolute;
      top: 0px;
      width: 100%;
    }
    .schedule-items {
      border-top: 1px solid map-get($grey, 'lighten-3');
      &.single {
        .v-row-group__header {
          visibility: collapse;
        }
      }
      .management {
        font-size: 8px !important;
        position: absolute;
        top: 4px;
        right: 4px;
      }
      .payroll-diff {
        font-size: 8px !important;
        position: absolute;
        top: 4px;
        left: 4px;
      }
      .request {
        font-size: 8px !important;
        position: absolute;
        top: 4px;
        right: 24px;
      }
      .non-duty {
        border-top: 1px solid map-get($grey, 'darken-3');
        display: inline-block;
        left: 12px;
        position: absolute;
        top: 10px;
        -webkit-transform: rotate(20deg);
        -moz-transform: rotate(20deg);
        -ms-transform: rotate(20deg);
        -o-transform: rotate(20deg);
        transform: rotate(20deg);
        width: 30px;

        &.custom-time {
          left: 2px;
          top: 18px;
          -webkit-transform: rotate(42deg);
          -moz-transform: rotate(42deg);
          -ms-transform: rotate(42deg);
          -o-transform: rotate(42deg);
          transform: rotate(42deg);
          width: 50px;
        }
      }
      .shift-type {
        &.modified {
          span {
            font-weight: bold !important;
          }
        }
      }
      thead {
        visibility: collapse;
      }
      tr {
        &.shift, &.event {
          td:first-child {
            border-left: 2px solid $secondary;
          }
        }
        &.v-data-table__expanded__content {
          background-color: map-get($grey, 'lighten-5') !important;
          box-shadow: none !important;
          td {
            border-left: 2px solid $secondary-lighten-3;
          }
        }
        th:nth-child(2) {
          padding: 0px;
          text-align-last: center;
        }
        td:nth-child(2) {
          background-color: #F4F4F4;
          padding: 0px;
        }
      }
      td {
        .name-n-avatar {
          width: 144px;
        }
      }
      .v-row-group__header {
        background-color: #F5F5FF !important;
        cursor: default;

        td, td:hover {
          border: none !important;
          color: map-get($grey, 'darken-3');
        }
      }
    }
    .v-row-group__header {
      background-color: map-get($nb-azure, 'base') !important;
      cursor: pointer;
      td {
        border-bottom: thin solid map-get($nb-azure, 'darken-1') !important;
      }
    }

    .v-data-table-header {
      th {
        border-top: 1px solid map-get($grey, 'lighten-3');
        color: map-get($grey, 'darken-3') !important;
        &.sortable {
          color: $secondary !important;
        }
      }
    }
  }
  .cell-details {
    transition: width 0.3s;
  }
  .badge-panel {
    &.count {
      .v-badge__wrapper {
        span {
          font-size: 10px;
          height: 16px;
          min-width: 16px;
          width: 16px;
        }
      }
    }
    .v-badge__badge {
      margin-left: -12px;
      padding-top: 4px;
    }
    .status {
      &.no-errors {
        display: none;
      }
    }
  }
  .job-count {
    background-color: $primary-lighten-2;
    border-radius: 4px;
    color: white;
    display: inline-block;
    height: 16px;
    line-height: 13px;
    padding-top: 1px;
    margin-top: -2px;
    min-width: 16px;
    text-align: center;

    &.sitter {
      background-color: $primary-lighten-4;
    }
    &.imbalance {
      background-color: $error !important;
    }
    &.inner-table {
      vertical-align: top;
      margin-top: 1px;
    }
    span {
      font-size: 10px;
    }
  }
  .last-shift-browser {
    .v-card {
      background-color: map-get($grey, 'lighten-5') !important;
      .row .col {
        padding-bottom: 0px;
      }
    }
  }
  .schedule-dropdown {
    border-color: map-get($grey, 'lighten-2');
    justify-content: start;
  }
  .sitter-info {
    span {
      width: 144px;
    }
  }
  .staff-new {
    position: absolute;
    right: -9px;
    bottom: 5px;
  }
  .staff-notes {
    position: absolute;
    right: -10px;
    top: 5px;
  }
  .has-errors {
    position: absolute;
    right: -6px;
    bottom: 8px;
  }
  .job-type-tabs {
    .v-slide-group__content {
      background-color: white;

      .v-tab--active {
        color: map-get($grey, 'darken-3') !important;
      }
    }
  }
  .flag-indicator {
    background-color: $info-lighten-2;
    border-color: $info-lighten-2;
    border-width: 1px;
    margin-top: -23px;
    position: absolute;
    width: 44px;
  }
}
.daily-schedule-notes {
  background-color: white;
}
#shareScheduleDialog {
  .daily-schedule-check {
    vertical-align: inherit;
  }
  .daily-schedule-label {
    width: 88px;
  }
  .dept-name {
    width: 145px;
  }
  .share-list {
    background-color: map-get($grey, 'lighten-5');
  }
  .share-progress {
    display: inline-block;
    vertical-align: inherit;
    width: 120px;
  }
  .share-progress-status {
    display: inline-block;
    margin-top: -4px;
    vertical-align: inherit;
  }
  .v-data-table__wrapper {
    .v-data-table-header {
      th {
        background-color: map-get($grey, 'lighten-5');
        border-bottom: none !important;
        color: $secondary !important;
        padding: 0px 4px;
      }
    }
    tbody {
      td, td:hover {
        border-bottom: none !important;
        height: 56px;
        padding: 10px 4px 0px 4px;
        vertical-align: top;
      }
    }
  }
}
.daily-schedule-picker {
  fieldset {
    background: $page-background !important;
  }
}
</style>
